"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRateCalculatorSectorOptionsDto = instanceOfRateCalculatorSectorOptionsDto;
exports.RateCalculatorSectorOptionsDtoFromJSON = RateCalculatorSectorOptionsDtoFromJSON;
exports.RateCalculatorSectorOptionsDtoFromJSONTyped = RateCalculatorSectorOptionsDtoFromJSONTyped;
exports.RateCalculatorSectorOptionsDtoToJSON = RateCalculatorSectorOptionsDtoToJSON;
exports.RateCalculatorSectorOptionsDtoToJSONTyped = RateCalculatorSectorOptionsDtoToJSONTyped;
/**
 * Check if a given object implements the RateCalculatorSectorOptionsDto interface.
 */
function instanceOfRateCalculatorSectorOptionsDto(value) {
    if (!('category' in value) || value['category'] === undefined)
        return false;
    if (!('sector' in value) || value['sector'] === undefined)
        return false;
    return true;
}
function RateCalculatorSectorOptionsDtoFromJSON(json) {
    return RateCalculatorSectorOptionsDtoFromJSONTyped(json, false);
}
function RateCalculatorSectorOptionsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'category': json['category'],
        'sector': json['sector'],
    };
}
function RateCalculatorSectorOptionsDtoToJSON(json) {
    return RateCalculatorSectorOptionsDtoToJSONTyped(json, false);
}
function RateCalculatorSectorOptionsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'category': value['category'],
        'sector': value['sector'],
    };
}
//# sourceMappingURL=RateCalculatorSectorOptionsDto.js.map